import KeenSlider from 'keen-slider'
import debounce from '../utils/debounce'

export default class Slider {
    constructor() {
        this.sliderContainers = document.querySelectorAll('.slider');
        if (!this.sliderContainers.length) { return }

        this.slideSelector = '.slider__item';
        this.defaultParams = {
            autoplayDuration: 6000,
            slides: this.slideSelector,
            buttonsContainer: false,
            markersContainer: false,
        }

        this.sliderContainers.forEach(function(el) {
            this.initSlider(el)
        }.bind(this))
    }
    
    initSlider(el, alreadyInit) {
        const params = this.getParams(el)
        const that = this;
        const isBrekpointOk =
        (!params.minWidth && !params.maxWidth) ||
        (!params.maxWidth || window.innerWidth < params.maxWidth) &&
        (!params.minWidth || window.innerWidth > params.minWidth)

        if (isBrekpointOk && !el.slider) {
            el.slider = new KeenSlider(el, {
                ...params,
                dragStart: (slider) => {
                    that.onSliderChange.bind(that)(slider.details(), el)

                    if (params.autoplay) {
                        Slider.autoplay(false, el);
                    }
                }, 
                dragEnd: () => {
                    if (params.autoplay) {
                        Slider.autoplay(true, el);
                    }
                },
                afterChange(slider) {
                    that.onSliderChange.bind(that)(slider.details(), el)

                    if (params.autoplay) {
                        Slider.autoplay(true, el);
                    }
                },
                move(slider) {
                    that.onSliderChange.bind(that)(slider.details(), el)
                }
            })
        }
    
        if (params.autoplay) {
            Slider.initAutoplay(el, params.autoplayDuration)
        }
        
        if (params.buttonsContainer) {
            el.buttonsContainer = document.querySelector(`${params.buttonsContainer}`)
            el.buttons = el.buttonsContainer.querySelectorAll('.slider__button')
            el.buttons[0].addEventListener('click', () => {el.slider.prev()})
            el.buttons[1].addEventListener('click', () => {el.slider.next()})
        }


        if (params.markersContainer) {
            el.markers = document.querySelectorAll(`${params.markersContainer} .slider__marker`)
            if (el.markers[0]) {
                el.markers[0].classList.add('active')
            }

            el.markers.forEach((e, i) => {
                e.addEventListener('click', (e) => {
                    e.preventDefault()
                    el.slider.moveToSlide(i)
                })
            })
        }

        if (!alreadyInit && (params.minWidth || params.maxWidth)) {
            window.addEventListener('resize', debounce(() => {this.resize(el, params)}, 300))
        }
    }

    resize(el, params) {
        if (params.maxWidth && window.innerWidth > params.maxWidth) {
            return this.destroy(el, params)
        }
        if (params.minWidth & window.innerWidth < params.minWidth) {
            return this.destroy(el, params)
        }
        this.initSlider(el, true)
    }

    destroy(el, params) {
        if (!el.slider) { return }
        el.slider.destroy();
        el.querySelectorAll(params.slides).forEach((e) => {
            e.style.minWidth = null
        })
        el.slider = false
    }

    static initAutoplay(slider, duration) {
        slider.autoplayDuration = duration
        // slider.addEventListener('mouseover', () => {
        //     Slider.autoplay(false, slider);
        // });
        // slider.addEventListener('mouseout', () => {
        //     Slider.autoplay(true, slider);
        // });
        Slider.autoplay(true, slider);

    }

    getParams(el) {
        if (!el) { return this.defaultParams }

        const dataParams = el.getAttribute('data-params');
        if (!dataParams) { return this.defaultParams }

        const params = JSON.parse(el.getAttribute('data-params'))
        return {...this.defaultParams, ...params}
    }

    static autoplay(run, el) {
        if (!el) {return}
        clearInterval(el.interval);
        el.interval = setInterval(() => {
            const position = el.getBoundingClientRect();
            // if element not visible
            if(position.top > window.innerHeight || position.bottom <= 0) { return }
            // if not runnnig or slider not defined
            if (!run || !el.slider) { return }

            const details = el.slider.details()
            let next = details.absoluteSlide + details.slidesPerView
            el.slider.moveToSlide(next)
        }, el.autoplayDuration);
    }

    onSliderChange(e, slider) {
        this.emitEvent(slider, e);
        slider.querySelectorAll(this.slideSelector).forEach((el, i) => {
            el.classList.remove('previous', 'next', 'active')

            if (slider.markers) {
                slider.markers.forEach((e) => {
                    e.classList.remove('active')
                })
                if (slider.markers[e.relativeSlide]) {
                    slider.markers[e.relativeSlide].classList.add('active')
                }
            }

            if (i < e.relativeSlide) {
                el.classList.add('previous')
            } else if (i > e.relativeSlide) {
                el.classList.add('next')
            } else if (i === e.relativeSlide) {
                el.classList.add('active')
            }   
        })
    }
    
    emitEvent(slider, e) {
        const event = new CustomEvent('slideChange', {detail: {...e}})
        slider.dispatchEvent(event)
    }
}